import Vue from 'vue'
import App from './App.vue'
import router from './pages/routers/index'
import FastClick from 'fastclick'
import VueLodash from 'vue-lodash'
import * as filters from "@/filtres/index"; // 全局过滤器
import api from '@/plugins/http'
const options = {
    name: 'lodash'
} // customize the way you want to call it
import dz from '@/assets/js/common'
import '@/assets/css/base.css'
import vueCookie from "vue-cookie"
import historyLogin from "@/plugins/historyLogin"

// 移除移动端点击延迟
const str= navigator.userAgent.toLowerCase()
const ver=str.match(/cpu iphone os (.*?) like mac os/)

if(!ver){//非IOS系统
    // 引入fastclick 做相关处理
    FastClick.attach(document.body)
} else {
    if(parseInt(ver[1])< 11){
        // 引入fastclick 做相关处理
        FastClick.attach(document.body)
    }
}
FastClick.prototype.focus = function (targetElement) {
    let length;
    if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
        length = targetElement.value.length;
        targetElement.focus();
        targetElement.setSelectionRange(length, length);
    } else {
        targetElement.focus();
    }
}

// 注册全局实用程序过滤器（register global utility filters）.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
document.documentElement.style.fontSize = 100 * window.innerWidth / 750 + 'px';
window.addEventListener("resize", () => {
    document.documentElement.style.fontSize = 100 * window.innerWidth / 750 + 'px';
})

Vue.use(VueLodash, options) // options is optional\
Vue.use(vueCookie)
//登录表单提交 actionurl
const ActionUrl = {
    school: process.env.VUE_APP_BASE_LOGIN_SCHOOL_URL + "site/put-login",
    teacher: process.env.VUE_APP_BASE_LOGIN_TEACHER_URL + "site/put-submit-login",
    parent: process.env.VUE_APP_BASE_LOGIN_PARENT_URL + "site/put-login-public",
    student: process.env.VUE_APP_BASE_LOGIN_STUDENT_URL + "site/put-login"
}
//target url
const targetUrl = {
    school: process.env.VUE_APP_BASE_LOGIN_SCHOOL_URL,
    teacher: process.env.VUE_APP_BASE_LOGIN_TEACHER_URL,
    parent: process.env.VUE_APP_BASE_LOGIN_PARENT_URL,
    student: process.env.VUE_APP_BASE_LOGIN_STUDENT_URL
}
Vue.prototype.ActionUrl = ActionUrl;
Vue.prototype.targetUrl = targetUrl;
Vue.prototype.api = api
Vue.prototype.dz = dz
Vue.prototype.lastLoginInfo = {}
Vue.config.productionTip = false
try {
    Vue.prototype.lastLoginInfo = JSON.parse(decodeURIComponent(localStorage.getItem("lastLoginInfo")) || "{}")
} catch (error) {
    console.log(error);
}

window.$cookie = vueCookie
let init = async function () {
    await historyLogin(ActionUrl, targetUrl);
    new Vue({
        router,
        render: h => h(App)
    }).$mount('#app')
}
init();
